<template>
  <div>
    <panel title="Nazwa ">
      <w-table
        entity-type="event"
        :hide-search-input="true"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />
    </panel>

    <event-modal :id="idToEdit" :show="showModal" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import EventModal from '@/components/modals/EventModal';
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania zdarzeń.',
  getError: 'Wystąpił błąd podczas pobierania danych zdarzeń.',
  added: 'Dodano zdarzenie.',
  addError: 'Nie udało się dodać zdarzenia.',
  updated: 'Zaktualizowano dane zdarzenia.',
  updateError: 'Nie udało się zaktualizować danych zdarzenia.',
  deleteConfirm: 'Czy na pewno chcesz usunąć zdarzenie?',
  deleted: 'Usunięto zdarzenie.',
  deleteError: 'Nie udało się usunąć zdarzenia.'
};

// @vuese
// Lista zdarzeń
// @group event
export default {
  components: { Panel, WTable, EventModal },
  mixins: [listMixin('event', messages)],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'name', displayName: 'Nazwa', sortable: true },
      { name: 'type', displayName: 'Typ' },
      { name: 'action', displayName: 'Akcja' }
    ],
    actions: DEFAULT_TABLE_ACTIONS
  })
};
</script>